module.exports = __webpack_public_path__ + "static/img/bg3.9cf201e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg3.jpg
// module id = 1226
// module chunks = 1